import { Controller } from "@hotwired/stimulus"

// Reveals the free-text "describe" field when the user picks "Andet"
// in the "Where did you hear about Cirkler?" dropdown.
export default class extends Controller {
  static targets = ["select", "otherPanel"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isOther = this.selectTarget.value === "Andet"
    this.otherPanelTarget.classList.toggle("hidden", !isOther)
  }
}
